module.exports = __webpack_public_path__ + "static/media/DaxlinePro-Regular.99a3ef97.ttf";